import { LOGOUT_URL } from '../constants';

import { OauthUserType, UserUrlMap } from './oauth.types';

const OAUTH_URL = '/client-oauth';
const LOGIN_URL = `${OAUTH_URL}/login`;
const LOGIN_TS_URL = `${LOGIN_URL}/ts`;
const LOGIN_EVOUCHER_URL = `${LOGIN_URL}/evoucher`;
const REFRESH_URL = `${OAUTH_URL}/token/refresh`;
const SILENT_LOGIN_URL = `${LOGIN_URL}/silent`;
const SILENT_LOGIN_TS_URL = `${LOGIN_TS_URL}/silent`;
const SILENT_LOGIN_EVOUCHER_URL = `${LOGIN_EVOUCHER_URL}/silent`;

export const LOGOUT_DATA_URL = `${OAUTH_URL}/logout-data`;
export const SWITCH_ACCOUNT_URL = `${OAUTH_URL}/switch-account`;
export const LOGOUT_REDIRECT_URL = `${LOGOUT_URL}?target=`;

export const LOGOUT_TOKEN_PLACEHOLDER = '{{access_token}}';
export const LOGOUT_STATE_PLACEHOLDER = '{{state}}';

export const LOGIN_URLS: UserUrlMap = new Map([
  [OauthUserType.DEFAULT, LOGIN_URL],
  [OauthUserType.AM, LOGIN_TS_URL],
  [OauthUserType.EVOUCHER, LOGIN_EVOUCHER_URL]
]);

export const SILENT_LOGIN_URLS: UserUrlMap = new Map([
  [OauthUserType.DEFAULT, SILENT_LOGIN_URL],
  [OauthUserType.AM, SILENT_LOGIN_TS_URL],
  [OauthUserType.EVOUCHER, SILENT_LOGIN_EVOUCHER_URL]
]);

export const REFRESH_URLS: UserUrlMap = new Map([
  [OauthUserType.DEFAULT, REFRESH_URL],
  [OauthUserType.AM, SILENT_LOGIN_TS_URL],
  [OauthUserType.EVOUCHER, SILENT_LOGIN_EVOUCHER_URL]
]);
